import axios from "../../interceptors/axiosInterceptor";
import {
  GET_PRODUCT_BRANDS_URL,
  GET_WAREHOUSE_URL,
  GET_PRODUCT_CITY_LEVEL_URL_V3,
  GET_PRODUCT_CITY_LEVEL_INVENTORY_URL,
  GET_UNIT_OF_MEASUREMENT_URL,
  UPDATE_PRODUCT_CITY_LEVEL_INVENTORY_URL_V2,
} from "../../config/Url";
import {
  IProductCategory,
  IGetQueryParams,
  IWarehousePayload,
  IProductCityLevelInventoryPayload,
  IProductCityLevelInventory,
  INormalizedProductCityLevelInventory,
  IIdValuePairResponse,
} from "../../interfaces/Index";
import { getAuthOptions } from "../../config/Headers";
import { normalizeCatchErrors } from "../../utils/errorUtils";
import {
  normalizeFetchProductCityLevelResponse,
  normalizeProductCityLevelBrand,
  normalizeWareHouseNames,
  normalizeProductCityLevelInventory,
} from "../../normalizer/ProductCityLevelNormalizer";

export const fetchProductCityLevelBrandApiCall = () =>
  new Promise<Array<IProductCategory>>((resolve, reject) => {
    axios
      .get(GET_PRODUCT_BRANDS_URL, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response && response.data;
          resolve(normalizeProductCityLevelBrand(data));
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchProductCityLevelsApiCall = (
  cityId: string,
  queryParam: IGetQueryParams = {}
) =>
  new Promise((resolve, reject) => {
    const url = GET_PRODUCT_CITY_LEVEL_URL_V3;
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    requestConfig.params.cityId = cityId;
    axios
      .get(url, requestConfig)
      .then((response) => {
        if (response) {
          const data = response && response.data;
          const pageNumber: number = queryParam.page
            ? Number(queryParam.page) + 1
            : 1;
          const isPaginatedRes =
            queryParam.page && (queryParam.page as any) > 0 && data.length >= 25
              ? true
              : false;
          resolve(
            normalizeFetchProductCityLevelResponse(
              data,
              pageNumber,
              isPaginatedRes
            )
          );
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const productCityLevelFetchWareHouseNamesApiCall = (queryParam: any) =>
  new Promise<IWarehousePayload[]>((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(GET_WAREHOUSE_URL, requestConfig)
      .then((response) => {
        if (response) {
          const data = response && response.data;
          resolve(normalizeWareHouseNames(data));
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchProductCityLevelInventoryApiCall = (
  id: string,
  queryParam: any
) =>
  new Promise<INormalizedProductCityLevelInventory[]>((resolve, reject) => {
    let url = GET_PRODUCT_CITY_LEVEL_INVENTORY_URL.replace("{product_id}", id);
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(url, requestConfig)
      .then((response) => {
        if (response) {
          const data: IProductCityLevelInventory[] =
            response.data.productDetails;
          resolve(normalizeProductCityLevelInventory(data));
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const updateProductCityLevelInventoryApiCall = (
  id: string,
  payload: IProductCityLevelInventoryPayload
) =>
  new Promise<void>((resolve, reject) => {
    let url = UPDATE_PRODUCT_CITY_LEVEL_INVENTORY_URL_V2.replace(
      "{product_id}",
      id as string
    );
    axios
      .put(url, payload, getAuthOptions(false))
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchProductSalesUomApiCall = (id: string = "") =>
  new Promise<Array<IIdValuePairResponse>>((resolve, reject) => {
    let url = `${GET_UNIT_OF_MEASUREMENT_URL}?uomId=${id}`;
    axios
      .get(url, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response && response.data;
          resolve(data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
